import validate from "/builds/sgdf/projets-benevoles/digiform/front/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0_supports-color@10.2.2___@_072b3e03c63bfa04ab7167085b6a8656/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/builds/sgdf/projets-benevoles/digiform/front/webapp/middleware/redirect.global.ts";
import manifest_45route_45rule from "/builds/sgdf/projets-benevoles/digiform/front/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0_supports-color@10.2.2___@_072b3e03c63bfa04ab7167085b6a8656/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "participants-redirect": () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/middleware/participants-redirect.ts")
}